import type { RouteObject } from 'react-router';
import { MiniappShell } from '@/shared/components/ui/MiniappShell';
import { TabBarLayout } from '@/shared/components/TabBarLayout';
import { CatalogPage } from '@/pages/CatalogPage';
import { MyClubsPage } from '@/pages/MyClubsPage';
import { ProfilePage } from '@/pages/ProfilePage';
import { ClubPage } from '@/pages/ClubPage';
import { ReaderPage } from '@/pages/ReaderPage';
import { PaywallPage } from '@/pages/PaywallPage';
import { RobokassaFailPage, RobokassaSuccessPage } from '@/pages/RobokassaReturnPage';
import { AuthPage } from '@/pages/AuthPage';
import { LegalHubPage } from '@/pages/LegalHubPage';
import { PaymentTermsPage } from '@/pages/PaymentTermsPage';
import { PublicOfferPage } from '@/pages/PublicOfferPage';
import { PrivacyPolicyPage } from '@/pages/PrivacyPolicyPage';
import { DefaultTabRedirect } from '@/pages/DefaultTabRedirect';
import { RequireWebAuth } from '@/features/auth/RequireWebAuth';
import { InstallGuidePage } from '@/features/pwa-install/InstallGuidePage';

/**
 * Route structure:
 * - "/" → DefaultTabRedirect (canonical entry → /catalog)
 * - Tab routes (with TabBarLayout): /catalog, /my-clubs, /profile
 * - Stack routes (no TabBar, full-screen): /clubs/:clubId
 *   Reader (/reader/:clubId/:chapterId) added in Phase 1.6
 */
export const routes: RouteObject[] = [
  {
    element: <MiniappShell />,
    children: [
      {
        path: '/',
        element: <DefaultTabRedirect />,
      },
      {
        path: '/auth',
        element: <AuthPage />,
      },
      {
        path: '/legal',
        element: <LegalHubPage />,
      },
      {
        path: '/legal/offer',
        element: <PublicOfferPage />,
      },
      {
        path: '/legal/payment',
        element: <PaymentTermsPage />,
      },
      {
        path: '/legal/privacy',
        element: <PrivacyPolicyPage />,
      },
      {
        path: '/install',
        element: <InstallGuidePage />,
      },
      {
        path: '/install/:platform',
        element: <InstallGuidePage />,
      },
      {
        element: <TabBarLayout />,
        children: [
          {
            path: '/catalog',
            element: <CatalogPage />,
          },
          {
            path: '/my-clubs',
            element: <RequireWebAuth />,
            children: [
              {
                index: true,
                element: <MyClubsPage />,
              },
            ],
          },
          {
            path: '/profile',
            element: <ProfilePage />,
          },
        ],
      },

      // ── Stack routes (no tab bar, full-screen) ────────────────────────────
      {
        path: '/clubs/:clubId',
        element: <ClubPage />,
      },
      {
        element: <RequireWebAuth />,
        children: [
          {
            path: '/reader/:clubId/:chapterId',
            element: <ReaderPage />,
          },
          {
            path: '/paywall/:clubSlug',
            element: <PaywallPage />,
          },
          {
            path: '/payments/robokassa/success',
            element: <RobokassaSuccessPage />,
          },
          {
            path: '/payments/robokassa/fail',
            element: <RobokassaFailPage />,
          },
        ],
      },
    ],
  },
];
